import React, {Component} from 'react';
import './RuhsatInfo.css';
import {DatePicker, Form, Input} from 'antd';


class RuhsatInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name:""
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
        };


        const tMezuniyetTarihi = this.props.memberInfo.mezuniyetTarihi ? {value:this.props.memberInfo.mezuniyetTarihi} : {};
        const tRuhsatTarihi = this.props.memberInfo.ruhsatTarihi ? {value:this.props.memberInfo.ruhsatTarihi} : {};


        return (
            <div class="ruhsatInfo-container">
                <Form {...formItemLayout}>
                    <Form.Item
                        label="Üniversite:">
                        <Input maxlength={50} value={this.props.memberInfo.universite}    onChange={(e)=>this.props.onInfoChange("universite",e.target.value)} />
                    </Form.Item>
                    <Form.Item
                        label="Mezuniyet Tarihi:">
                        <DatePicker format= "DD.MM.YYYY" {...tMezuniyetTarihi} placeholder="Tarih Seçiniz" style={{ width: '100%' }} onChange={(dateString)=>this.props.onInfoChange("mezuniyetTarihi",dateString)}  />

                    </Form.Item>
                    <Form.Item
                        label="Diploma No:">
                        <Input maxlength={25} value={this.props.memberInfo.diplomaNo}   onChange={(e)=>this.props.onInfoChange("diplomaNo",e.target.value)}  />
                    </Form.Item>
                    <Form.Item
                        label="Ruhsat No:">
                        <Input maxlength={25} value={this.props.memberInfo.ruhsatNo}  onChange={(e)=>this.props.onInfoChange("ruhsatNo",e.target.value)}  />
                    </Form.Item>
                    <Form.Item
                        label="Ruhsat Tarihi">
                        <DatePicker format= "DD.MM.YYYY" {...tRuhsatTarihi} placeholder="Tarih Seçiniz" style={{ width: '100%' }} onChange={( dateString)=>this.props.onInfoChange("ruhsatTarihi",dateString)}  />
                    </Form.Item>
                    <Form.Item
                        label="Vergi Dairesi Adı:">
                        <Input maxlength={50} value={this.props.memberInfo.vergiDairesiAd}   onChange={(e)=>this.props.onInfoChange("vergiDairesiAd",e.target.value)}  />
                    </Form.Item>
                    <Form.Item
                        label="Vergi No:">
                        <Input maxlength={10} value={this.props.memberInfo.vergiNo}  onChange={(e)=>this.props.onInfoChange("vergiNo",e.target.value)}  />
                    </Form.Item>



                </Form>
            </div>
        );
    }


}
export default RuhsatInfo;



// WEBPACK FOOTER //
// ./src/page/ruhsatInfo/RuhsatInfo.js